import React from "react"
import Dropzone from 'react-dropzone'
import style from "./style.module.sass"
import { useTheme } from "@material-ui/styles"

export const Dnd = ({ onReadDropFiles, text, disabled }) => {
    const {theme: {bgColors, colors, borderColors}} = useTheme()
    return (
        <Dropzone disabled={disabled} onDrop={onReadDropFiles}>
            {({ getRootProps, getInputProps }) => (
                <section className={style.dnd} style={{ backgroundColor: bgColors.bgDnd, color: colors.colorDndText,
                    borderColor: borderColors.borderGold
                 }}>
                    <div {...getRootProps()} className="mx-auto my-auto row" >
                        <input {...getInputProps()} />
                        <div className={style.dndText} style={{color: colors.colorDndText}}>{text}</div>
                    </div>
                </section>
            )}
        </Dropzone>
    )
}